export const LANGUAGES = [
    {
        value: "en-US",
        label: "English",
        flag: "🇺🇸",
        voice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-male-en.m4a`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-female-en.m4a`
        },
        setupVoice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/en-male.mp3`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/en-female.mp3`
        }
    },
    {
        value: "English - Malaysian",
        label: "English - Malaysian (Premium)",
        flag: "🇲🇾",
        voice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-male-my-en-2.m4a`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-female-my-en.m4a`
        },
        setupVoice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/my-male.mp3`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/my-female.mp3`
        }
    },
    {
        value: "Malay",
        label: "Malay (Premium)",
        flag: "🇲🇾",
        voice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-male-my-2.m4a`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-female-my-2.m4a`
        },
        setupVoice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/my-male.mp3`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/my-female.mp3`
        }
    },
    {
        value: "id-ID",
        label: "Indonesian",
        flag: "🇮🇩",
        voice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-male-indo-3.m4a`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-female-indo-3.m4a`
        },
        setupVoice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/id-male.mp3`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/id-female.mp3`
        }
    },
    {
        value: "vi-VN",
        label: "Vietnamese",
        flag: "🇻🇳",
        voice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-male-viet.m4a`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/ot-female-viet.m4a`
        },
        setupVoice: {
            male: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/vn-male.mp3`,
            female: `${import.meta.env.VITE_ASSET_OURTEAM_BASE_URL}/commons/example-voice/training/vn-female.mp3`
        }
    },
];

// Maps the short language codes stored on training personas in the DB
// (GET /training/personas/:id → `language`) to the LANGUAGES[].value above.
export const PERSONA_LANGUAGE_CODE_MAP: Record<string, string> = {
    en: "en-US",
    id: "id-ID",
    my: "Malay",
    vn: "vi-VN",
};

// Resolve a language identifier — either a short DB code ("en", "id", "my", "vn")
// or an already-full LANGUAGES[].value ("en-US", "Malay", …) — to its LANGUAGES entry.
// Returns undefined when the code is empty or unrecognised, so callers can fall back.
export function resolveLanguage(code?: string | null) {
    if (!code) return undefined;
    const mapped = PERSONA_LANGUAGE_CODE_MAP[code.toLowerCase()] ?? code;
    return LANGUAGES.find((l) => l.value === mapped);
}